import { render, staticRenderFns } from "./PilaDocumentos.vue?vue&type=template&id=7b59e7fd&scoped=true&"
import script from "./PilaDocumentos.vue?vue&type=script&lang=js&"
export * from "./PilaDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./PilaDocumentos.vue?vue&type=style&index=0&id=7b59e7fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b59e7fd",
  null
  
)

export default component.exports